import { useEffect } from 'react';

export default function usePageTitle(title, alertCount = 0) {
  useEffect(() => {
    const prefix = alertCount > 0 ? `\uD83D\uDD34 ${alertCount} | ` : '';
    document.title = title ? `${prefix}${title} | GSS-360` : `${prefix}GSS-360`;
    return () => { document.title = 'GSS-360'; };
  }, [title, alertCount]);
}
